module.exports = __webpack_public_path__ + "img/6.f87cb62a.jpg";